import axios from "axios";
import Session from "../utils/Session";
var randomstring = require("randomstring");

export const api = axios.create({
    //baseURL: "http://localhost:8086/api/v1/",
    //baseURL: "http://localhost:8082/api/v1/",
    baseURL:"https://staging.api.smartleads.marketing/api/v1/",
    //baseURL: "https://prestg.api.smartleads.marketing/api/v1/",
    headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${Session.getToken()}`
    },
});

export function authenticate(userName, pass) {
    Session.clear();
    const url = "login";

    return api.post(url, {
        username: userName,
        password: pass,
    }).then(function ({data}) {
        if (data !== undefined && data.access_token !== null) {
            Session.setToken(data.access_token, data.expiration);

            Session.setUser({
                userName,
                isAdmin: true,
            });
            return {
                success: true,
            };
        } else {
            return {
                success: false,
                reason: "",
            };
        }
    });

}

export  function getClientId(){
    return  api.get('getClientId')
}

export const hashh = randomstring.generate(5);

export const createCampaign = async (values) => {
    const url = "estrategias/create";
    const request = {
        fechaLanzamiento: values.fechaLanzamiento,
        fechaVencimiento: values.fechaVencimiento,
        habilitada: values.habilitada,
        nombre: values.nombre,
        hash: values.hash,
        nroCliente: values.nroCliente,
    };

    return await api.post(url, request);
};

export const updateCampaign = async (values) => {
    const url = "estrategias/update";
    const request = {
        fechaLanzamiento: values.fechaLanzamiento,
        fechaVencimiento: values.fechaVencimiento,
        habilitada: values.habilitada,
        nombre: values.nombre,
        hash: values.hash,
        nroCliente: values.nroCliente,
        id: values.id,
    };
    return await api.put(url, request);
};

export const addParametrs = async (values) => {
    const url = `parametros/create`;
    const request = {
        texto: values.texto,
        habilitaNombre: values.habilitaNombre,
        habilitaApellido: values.habilitaApellido,
        habilitaLocalidad: values.habilitaLocalidad,
        habilitaProvincia: values.habilitaProvincia,
        validaEmail: values.validaEmail,
        validaSms: values.validaSms,
        validaScore: values.validaScore,
        validaDni: values.validaDni,
        imagenBackground: values.imagenBackground,
        imagenLogo: values.imagenLogo,
        estrategia: values.estrategia,
        hash: values.hash,
        textoSobreImagen: values.textoSobreImagen,
        textoDebajoImagen: values.textoDebajoImagen,
        textoPieFormulario: values.textoPieFormulario,
        titulo1Formulario: values.titulo1Formulario,
        detalle1Formulario: values.detalle1Formulario,
        titulo2Formulario: values.titulo2Formulario,
        detalle2Formulario: values.detalle2Formulario,
        titulo3Formulario: values.titulo3Formulario,
        detalle3Formulario: values.detalle3Formulario,
        titulo4Formulario: values.titulo4Formulario,
        detalle4Formulario: values.detalle4Formulario,
        titulo5Formulario: values.titulo5Formulario,
        detalle5Formulario: values.detalle5Formulario,
    };
    console.log("api add parametross");
    console.log(request);
    return await api.post(url, request);
};

export const updateParametrs = async (values) => {
    const url = `parametros/update`;
    const request = {
        id: values.id,
        texto: values.texto,
        habilitaNombre: values.habilitaNombre,
        habilitaApellido: values.habilitaApellido,
        habilitaLocalidad: values.habilitaLocalidad,
        habilitaProvincia: values.habilitaProvincia,
        validaEmail: values.validaEmail,
        validaSms: values.validaSms,
        validaScore: values.validaScore,
        validaDni: values.validaDni,
        imagenBackground: values.imagenBackground,
        imagenLogo: values.imagenLogo,
        estrategia: values.estrategia,
        hash: values.hash,
        textoSobreImagen: values.textoSobreImagen,
        textoDebajoImagen: values.textoDebajoImagen,
        textoPieFormulario: values.textoPieFormulario,
        titulo1Formulario: values.titulo1Formulario,
        detalle1Formulario: values.detalle1Formulario,
        titulo2Formulario: values.titulo2Formulario,
        detalle2Formulario: values.detalle2Formulario,
        titulo3Formulario: values.titulo3Formulario,
        detalle3Formulario: values.detalle3Formulario,
        titulo4Formulario: values.titulo4Formulario,
        detalle4Formulario: values.detalle4Formulario,
        titulo5Formulario: values.titulo5Formulario,
        detalle5Formulario: values.detalle5Formulario,
    };
    return await api.put(url, request);
};

export const getCampaignsByClient = async (clientId) => {
    const url = `estrategias/findByClient?nroCliente=${clientId}`;
    return await api.get(url);
};

export const getCampaignByHash = async (hash) => {
    const url = `estrategias/findByHash?hash=${hash}`;
    return await api.get(url);
};

//obtener parametros
export const getParametrosByHash = async (hash) => {
    const url = `parametros/findByHashForBack?hash=${hash}`;
    return await api.get(url);
};

//eliminar parametros
export const deleteParametros = async (id) => {
    const url = `parametros/${id}`;
    return await api.delete(url);
};
//eliminar campaña
export const deleteCampania = async (id) => {
    const url = `estrategias/${id}`;
    return await api.delete(url);
};

//eliminar campaña
export const getLeadsById = async (id) => {
    const url = `contactos/findByEstrategia?estrategiaId=${id}`;
    return await api.get(url);
};



// WEBPACK FOOTER //
// ./src/scenes/api.js